import React, { useState } from 'react';
import '../styles/Menu.css';
import { MENU_DATA } from '../constants/data';

function Menu() {
  const menuData = MENU_DATA;

  // Initialize all accordions as open by default
  const [activeAccordions] = useState(
    Object.keys(menuData).reduce((acc, key) => ({ ...acc, [key]: true }), {})
  );

  // const toggleAccordion = (category) => {
  //   setActiveAccordions(prev => ({
  //     ...prev,
  //     [category]: !prev[category]
  //   }));
  // };

  return (
  <section id="menu" className="menu-section">
    <div className="menu-container">
      <h2>Our Menu</h2>
      <div className="menu-grid">
        {Object.entries(menuData).map(([key, category], index) => (
          <div
            key={key}
            className={`menu-category ${index % 2 === 0 ? 'left' : 'right'}`}
          >
            <div
              className={`category-header ${activeAccordions[key] ? 'active' : ''}`}
            //   onClick={() => toggleAccordion(key)}
            >
              <h3>{category.title}</h3>
              {/* <span className="accordion-icon">
                {activeAccordions[key] ? 'CLOSE' : 'EXPAND'}
              </span> */}
            </div>
            <div className={`menu-items ${activeAccordions[key] ? 'active' : ''}`}>
              <ul>
                {category.items.map((item, index) => (
                  <li key={index}>
                    {item.name.toLocaleLowerCase()}
                    <span className="price-dots"></span>
                    <span className="price">${item.price}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

}

export default Menu;
